import React from 'react';
import Activities from "./Activities";

export default function Library() {
    return <Activities isStarted={null}/>;
}
